import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { initSentry, Sentry } from "./lib/sentry.js";

// Init before anything else so module-load errors are captured.
initSentry();

window.TWEAK_DEFAULTS = {
  monitorViz: "spark",
};

await import("./components/icons.jsx");
await import("./components/primitives.jsx");
await import("./tweaks-panel.jsx");
await import("./components/dashboard.jsx");
await import("./components/goal-box.jsx");
await import("./components/suggester.jsx");
await import("./components/offer-monitor.jsx");
await import("./components/diagnoser.jsx");
await import("./components/data-requests.jsx");
await import("./components/post-mortem.jsx");
await import("./components/rejections.jsx");
await import("./App.jsx");

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: 24, fontFamily: "system-ui", color: "var(--text-1)" }}>
          <h2 style={{ marginTop: 0 }}>Something broke.</h2>
          <p style={{ color: "var(--text-2)" }}>
            The error was reported. Try reloading the page.
          </p>
          <pre style={{ fontSize: 11, color: "var(--text-3)", whiteSpace: "pre-wrap" }}>
            {error?.message ?? String(error)}
          </pre>
          <button className="btn btn--primary" onClick={resetError}>Reload view</button>
        </div>
      )}
    >
      <window.App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
